export const createTocNodeSpec = () => {
    return {
        attrs: {
            expanded: { default: false },
        },
        content: "bullet_list",
        group: "block",
        atom: true,
        selectable: false,
        toDOM: (node) => [
            "div",
            {
                class: `table-of-contents ${node.attrs.expanded ? "table-of-contents--expanded" : ""}`,
                contenteditable: "false",
            },
            [
                "div",
                { class: "table-of-contents__head" },
                ["div", { class: "table-of-contents__head-arrow" }],
                [
                    "div",
                    { class: "table-of-contents__head-title" },
                    `Table of Contents`, // TODO: localize
                ],
            ],
            ["div", { class: "table-of-contents__content" }, 0],
        ],
        parseDOM: [
            {
                tag: "div.table-of-contents",
                getAttrs: (element) => {
                    return {
                        expanded: element.classList.contains("table-of-contents--expanded"),
                    };
                },
            },
        ],
    };
};
